import { axios } from '../../../util/axios'
import lastLoginStorage from '../../../util/lastLoginStorage'
import platform from '../../../util/platform'

const API_ENDPOINT = '/v3/google'
const API_V4_ENDPOINT = '/v4/google'

export const googleLoginApi = (idToken, sessionTokens, abTests) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-google'
  return axios
    .post(
      API_ENDPOINT,
      {
        idToken,
        platform,
        session_ids: sessionTokens,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
        },
        withCredentials: true,
      }
    )
    .then(response => {
      const { data } = response
      lastLoginStorage.saveGoogleLogin(data)
      return response
    })
}

export const googleLoginApiValidation = (idToken, sessionTokens) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-google'
  return axios
    .post(
      API_V4_ENDPOINT,
      {
        idToken,
        platform,
        session_ids: sessionTokens,
      },
      { withCredentials: true }
    )
    .then(response => {
      const { data } = response
      lastLoginStorage.saveGoogleLogin(data)
      return response
    })
}
